export const member = {
  validatePass: '请输入密码, 6字以上大小写英文数字',
  confirmPass: '请再次输入密码',
  validateConfirmPass: '請輸入相同密码'
}
